/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Other5Inputs */

const en_cv_extract_form_enum_other5 = /** @type {(inputs: Cv_Extract_Form_Enum_Other5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de_cv_extract_form_enum_other5 = /** @type {(inputs: Cv_Extract_Form_Enum_Other5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Cv_Extract_Form_Enum_Other5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_other5 = /** @type {((inputs?: Cv_Extract_Form_Enum_Other5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Other5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_other5(inputs)
	return en_cv_extract_form_enum_other5(inputs)
});
export { cv_extract_form_enum_other5 as "cv_extract_form_enum_OTHER" }